var $b63105d663e6f9d5$exports = {};
$b63105d663e6f9d5$exports = {
  "breadcrumbs": "Navigointilinkit"
};
export { $b63105d663e6f9d5$exports as default };